<template>

  <!-- BODY -->
  <validation-observer
    #default="{ handleSubmit, invalid }"
    ref="refFormObserver"
  >
    <!-- Form -->
    <b-form
      class="p-2"
      @submit.prevent="handleSubmit(onSubmit)"
      @reset.prevent="resetForm"
    >

      <template
        v-if="section === 'specifics'"
      >
        <!-- Quality -->
        <validation-provider
          #default="validationContext"
          name="Quality"
          rules="required"
        >
          <b-form-group
            label="Quality *"
            label-for="quality"
            :state="getValidationState(validationContext)"
          >
            <b-form-select
              v-model="materialData.specifics.quality"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="qualityOptions"
              input-id="quality"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </template>

      <template
        v-if="section === 'dimensions'"
      >
        <!-- Bag Width -->
        <b-form-group
          label="Bag Width"
          label-for="bag-width"
        >
          <b-input-group>
            <b-form-input
              id="bag-width"
              v-model="materialData.dimensions.bag_width"
              trim
            />
            <b-input-group-append>
              <b-form-select
                v-model="materialData.dimensions.bag_width_units"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="bagWidthUnitsOptions"
                input-id="bag-width-units"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!-- Bag Length -->
        <b-form-group
          label="Bag Length"
          label-for="bag-length"
        >
          <b-input-group>
            <b-form-input
              id="bag-length"
              v-model="materialData.dimensions.bag_length"
              trim
            />
            <b-input-group-append>
              <b-form-select
                v-model="materialData.dimensions.bag_length_units"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="bagLengthUnitsOptions"
                input-id="bag-length-units"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!-- Print Width -->
        <b-form-group
          label="Print Width"
          label-for="print-width"
        >
          <b-input-group>
            <b-form-input
              id="print-width"
              v-model="materialData.dimensions.print_width"
              trim
            />
            <b-input-group-append>
              <b-form-select
                v-model="materialData.dimensions.print_width_units"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="printWidthUnitsOptions"
                input-id="print-width-units"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!-- Print Length -->
        <b-form-group
          label="Print Length"
          label-for="print-length"
        >
          <b-input-group>
            <b-form-input
              id="print-length"
              v-model="materialData.dimensions.print_length"
              trim
            />
            <b-input-group-append>
              <b-form-select
                v-model="materialData.dimensions.print_length_units"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="printLengthUnitsOptions"
                input-id="print-length-units"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!-- Embroidery Width -->
        <b-form-group
          label="Embroidery Width"
          label-for="embroidery-width"
        >
          <b-input-group>
            <b-form-input
              id="embroidery-width"
              v-model="materialData.dimensions.embroidery_width"
              trim
            />
            <b-input-group-append>
              <b-form-select
                v-model="materialData.dimensions.embroidery_width_units"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="embroideryWidthUnitsOptions"
                input-id="embroidery-width-units"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!-- Embroidery Length -->
        <b-form-group
          label="Embroidery Length"
          label-for="embroidery-length"
        >
          <b-input-group>
            <b-form-input
              id="embroidery-length"
              v-model="materialData.dimensions.embroidery_length"
              trim
            />
            <b-input-group-append>
              <b-form-select
                v-model="materialData.dimensions.embroidery_length_units"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="embroideryLengthUnitsOptions"
                input-id="embroidery-length-units"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </template>

      <template
        v-if="section === 'color'"
      >
        <!-- Base Color -->
        <b-form-group
          label="Base Color"
          label-for="base-colors"
        >
          <v-select
            v-model="materialData.colors"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="colorOptions"
            :reduce="val => val.value"
            multiple
            :clearable="false"
            input-id="base-colors"
          >
            <template v-slot:option="option">
              <span
                :style="{backgroundColor: option.color,
                         marginRight: '5px', width: '20px', height:'20px',
                         borderRadius: '4px', display:'inline-block'}"
              /><span>{{ option.label }}</span>
            </template>
          </v-select>
        </b-form-group>

        <!-- Other Colors -->
        <b-form-group
          label="Other Color"
          label-for="other-colors"
        >
          <v-select
            v-model="materialData.other_colors"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="colorOptions"
            :reduce="val => val.value"
            multiple
            :clearable="false"
            input-id="other-colors"
          >
            <template v-slot:option="option">
              <span
                :style="{backgroundColor: option.color,
                         marginRight: '5px', width: '20px', height:'20px',
                         borderRadius: '4px', display:'inline-block'}"
              /><span>{{ option.label }}</span>
            </template>
          </v-select>
        </b-form-group>
      </template>

      <template
        v-if="section === 'images'"
      >
        <!-- Image -->
        <style-media-grid-form
          :style-media="styleMedia"
          :submit-handler="submitHandler"
          :fetch-style-material-media="fetchStyleMaterialMedia"
        />
      </template>

      <template
        v-if="section === 'sourcing'"
      >
        <!-- Reference -->
        <b-form-group
          label="Ref"
          label-for="ref"
        >
          <b-form-input
            id="ref"
            v-model="materialData.ref"
            trim
          />
        </b-form-group>

        <!-- Supplier -->
        <b-form-group
          label="Supplier"
          label-for="supplier"
        >
          <b-form-select
            v-model="materialData.supplier"
            :options="supplierOptions"
            input-id="supplier"
          />
        </b-form-group>

        <!-- Price -->
        <b-form-group
          label="Price"
          label-for="price"
        >
          <b-form-input
            id="price"
            v-model="materialData.price"
            trim
            placeholder="0.00"
          />
        </b-form-group>
      </template>

      <template
        v-if="section === 'consumption'"
      >
        <!-- Quantity -->
        <b-form-group
          label="Quantity"
          label-for="quantity"
        >
          <b-form-select
            v-model="materialData.consumption.quantity"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="quantityOptions"
            input-id="quantity"
          />
        </b-form-group>
      </template>

      <template
        v-if="section === 'placement'"
      >
        <!-- Placement -->
        <b-form-group
          label="Placement"
          label-for="placement"
        >
          <b-form-textarea
            id="placement"
            v-model="materialData.placement"
            trim
            rows="3"
            max-rows="5"
          />
        </b-form-group>
      </template>

      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-2"
          type="submit"
          :disabled="invalid"
        >
          Next
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import _ from 'lodash'
import {
  BButton, BForm, BFormGroup, BFormInput,
  BFormInvalidFeedback, BFormSelect, BFormTextarea,
  BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref, watch } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import router from '@/router'

import StyleMediaGridForm from './StyleMediaGridForm.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormSelect,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,

    StyleMediaGridForm,
  },
  directives: {
    Ripple,
  },
  props: {
    colorOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    supplierOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    section: {
      type: String,
      required: true,
    },
    submitHandler: {
      type: Function,
      required: false,
      default: null,
    },
    fetchStyleMaterialMedia: {
      type: Function,
      required: false,
      default: null,
    },
    styleMedia: {
      type: Array,
      required: false,
      default: () => [],
    },
    initData: {
      type: Object,
      required: false,
      default: () => ({
        specifics: {}, dimensions: {}, consumption: {},
      }),
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props) {
    const qualityOptions = [
      'Paper',
      'Cotton',
      'My own fabric waste',
      'Other',
    ]
    const bagWidthUnitsOptions = [
      'cm',
    ]
    const bagLengthUnitsOptions = [
      'cm',
    ]
    const printWidthUnitsOptions = [
      'mm',
      'cm',
    ]
    const printLengthUnitsOptions = [
      'mm',
      'cm',
    ]
    const embroideryWidthUnitsOptions = [
      'mm',
      'cm',
    ]
    const embroideryLengthUnitsOptions = [
      'mm',
      'cm',
    ]
    const quantityOptions = [
      '<100',
      '<300',
      '<500',
      '>500',
    ]

    const materialDataInit = {
      specifics: {},
      consumption: {},
      dimensions: {},
    }
    const materialData = ref({ ...materialDataInit })

    const resetMaterialData = () => {
      materialData.value = { ...materialDataInit }
    }

    watch(() => props.initData, newValue => {
      if (newValue !== undefined) {
        materialData.value = _.cloneDeep(newValue)
      }
    }, { deep: true, immediate: true })

    const onSubmit = () => {
      const { section } = props
      let formData = {}

      switch (section) {
        case 'specifics':
        case 'dimensions':
        case 'consumption':
        case 'placement':
          formData = { [section]: materialData.value[section] }
          break
        case 'color':
          formData = {
            colors: materialData.value.colors,
            other_colors: materialData.value.other_colors,
          }
          break
        case 'sourcing':
          formData = {
            ref: materialData.value.ref,
            supplier: materialData.value.supplier,
            price: materialData.value.price,
          }
          break
        default:
          formData = {}
      }
      props.submitHandler({
        id: materialData.value.id || router.currentRoute.params.id,
        category_type: 'Bag',
        ...formData,
      })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetMaterialData)

    return {
      qualityOptions,
      bagWidthUnitsOptions,
      bagLengthUnitsOptions,
      printWidthUnitsOptions,
      printLengthUnitsOptions,
      embroideryWidthUnitsOptions,
      embroideryLengthUnitsOptions,
      quantityOptions,
      materialData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>
